<template>
  <div class="floating-icons" :class="{ 'collapsed': isCollapsed }">
    <!-- 主按钮 -->
    <!-- <div class="main-button" @click="toggleCollapse">
      <svg viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
      </svg>
    </div> -->

    <!-- 图标菜单 -->
    <div class="icon-menu">
      <!-- 二维码 -->
      <!-- <div class="icon-item" @mouseenter="showTooltip('qr')" @mouseleave="hideTooltip">
        <svg viewBox="0 0 24 24">
          <path d="M3 11h2v2H3zm0 4h2v2H3zm0-8h2v2H3zm4 4h14v2H7zm0 4h14v2H7zm0-8h14v2H7z"/>
        </svg>
        <div v-if="activeTooltip === 'qr'" class="tooltip">
          <img src="@/assets/images/qr-code.jpg" alt="微信公众号二维码" class="qr-code">
          <p>扫码关注公众号</p>
        </div>
      </div> -->

      <!-- 联系电话 -->
      <div class="icon-item" @click="callPhone" @mouseenter="showTooltip('phone')" @mouseleave="hideTooltip">
        <svg viewBox="0 0 24 24">
          <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
        </svg>
        <div v-if="activeTooltip === 'phone'" class="tooltip">
          <p>联系电话: 18938645071</p>
        </div>
      </div>
      <!-- 返回顶部 -->
      <div class="icon-item" @click="scrollToTop" @mouseenter="showTooltip('top')" @mouseleave="hideTooltip">
        <svg viewBox="0 0 24 24">
          <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
        </svg>
        <div v-if="activeTooltip === 'top'" class="tooltip">
          <p>返回顶部</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isCollapsed = ref(false)
const activeTooltip = ref(null)

// const toggleCollapse = () => {
//   isCollapsed.value = !isCollapsed.value
// }

const showTooltip = (type) => {
  activeTooltip.value = type
}

const hideTooltip = () => {
  activeTooltip.value = null
}


const callPhone = () => {
  // 点击拨打电话
  window.location.href = 'tel:4001234567'
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
</script>

<style scoped>
.floating-icons {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  transition: all 0.3s ease;
}

.main-button {
  width: 50px;
  height: 50px;
  background-color: var(--primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
}

.main-button svg {
  width: 24px;
  height: 24px;
  fill: white;
}

.icon-menu {
  display: flex;
  flex-direction: column;
  gap: 15px;
  opacity: 1;
  transform: translateX(0);
  transition: all 0.3s ease;
}

.floating-icons.collapsed .icon-menu {
  opacity: 0;
  transform: translateX(100px);
  pointer-events: none;
}

.icon-item {
  width: 40px;
  height: 40px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: all 0.2s ease;
}

.icon-item:hover {
  background-color: var(--primary);
  transform: scale(1.1);
}

.icon-item:hover svg {
  fill: white;
}

.icon-item svg {
  width: 20px;
  height: 20px;
  fill: var(--primary);
  transition: all 0.2s ease;
}

.tooltip {
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  font-size: 14px;
}

.tooltip p {
  margin: 0;
  color: var(--dark);
}

.qr-code {
  width: 120px;
  height: 120px;
  margin-bottom: 5px;
}

@media (max-width: 768px) {
  .floating-icons {
    right: 10px;
  }
  
  .main-button {
    width: 40px;
    height: 40px;
  }
  
  .icon-item {
    width: 35px;
    height: 35px;
  }
  
  .tooltip {
    font-size: 12px;
  }
  
  .qr-code {
    width: 100px;
    height: 100px;
  }
}
</style>